import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import api from "../../../services/api";
import DeleteModal from "../../../core/modals/deleteModal";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import EditCompany from "./edit_company_modal";

//import CrmsModal from '../../../core/modals/crms_modal'

const CompaniesGrid = () => {
  const location = useLocation();
  const routes = all_routes;
  const signature = localStorage.getItem("signature");

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false); // state to track loading

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("userService/deleteChildCompany", {
            signature,
            id,
          });
          await updateUI();
          setIsLoading(false); // hide loader after response
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          setIsLoading(false); // hide loader after response
          showBasicAlert(error.data.message[0].msg);
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };

  const [modalData, setModalData] = useState(null);

  const handleEditOpenModal = (record: any) => {
    record.signature = signature;
    record.id = record.key;
    setModalData(record);
  };

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      await updateUI();
    };

    fetchDashboardData();
  }, []);

  const updateUI = async () => {
    try {
      const [complanyList] = await Promise.all([
        api.post("userService/getChildCompanyList", { signature }),
      ]);
      setData(complanyList.data.data.data);
      setFilteredData(complanyList.data.data.data);

      return;
    } catch (err: any) {
      showBasicAlert(err.data.message[0].msg);
    }
  };

  const defaultCompanyData = {
    Address1: "",
    Address2: "",
    City: "",
    Company_Name: "",
    Country: "",
    CreatedDate: "",
    Email: "",
    Facebook: "",
    Image: "",
    Image2: "",
    Instagram: "",
    Phone: "",
    Pincode: "",
    State: "",
    Status: "",
    Twitter: "",
    Website: "",
    phone_code: "",
    signature: "",
    countries: [],
    statesOrignal: [],
    citiesOrignal: [],
    Linkedin: "",
    Location: "",
    Whatsapp: "",
    key: "",
    Password: "",
    logo: "",
  };
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.Company_Name.localeCompare(b.Company_Name);
            case "Descending":
              return b.Company_Name.localeCompare(a.Company_Name);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [sortBy]);

  const handleReset = () => {
    setFilteredData(data);
    setSortBy("Last 7 Days");
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Companies</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Companies Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={`${routes.companiesList}${location?.search}`}
                    className="btn btn-icon btn-sm me-1"
                    title="List">
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={`${routes.companiesGrid}${location?.search}`}
                    className="btn btn-icon btn-sm active bg-primary text-white"
                    title="Grid">
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <h5>Companies Grid</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown">
                      Sort By: {sortBy}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Recently Added");
                          }}>
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Ascending");
                          }}>
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Descending");
                          }}>
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last Month");
                          }}>
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last 7 Days");
                          }}>
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleReset}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {filteredData.map((company, index) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6"
                key={JSON.stringify(company)}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="form-check form-check-md">
                        {/* <input className="form-check-input" type="checkbox" /> */}
                      </div>
                      <div>
                        <Link
                          to={`${routes.companiesDetails.replace(
                            ":id",
                            company.key
                          )}${location?.search}`}
                          className="avatar avatar-xl border rounded-circle d-flex align-items-center justify-content-center bg-light text-uppercase fw-bold text-primary"
                          style={{ width: 60, height: 60 }}>
                          {company.Image ? (
                            <img
                              src={company.Image}
                              alt={company.Company_Name}
                              className="img-fluid rounded-circle"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            company.Company_Name?.charAt(0)
                          )}
                        </Link>
                      </div>

                      <div className="dropdown">
                        <button
                          className="btn btn-icon btn-sm rounded-circle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <i className="ti ti-dots-vertical" />
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_company"
                              onClick={(e: any) => {
                                e.preventDefault();
                                handleEditOpenModal(company);
                              }}>
                              <i className="ti ti-edit me-1" />
                              Edit
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete_modal"
                              onClick={(e: any) => {
                                e.preventDefault();
                                setDeleteRecord(company);
                              }}>
                              <i className="ti ti-trash me-1" />
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="d-flex flex-column">
                      <p className="text-dark d-inline-flex align-items-center mb-2">
                        <i className="ti ti-building text-gray-5 me-2" />
                        {company.Company_Name}
                      </p>
                      <p className="text-dark d-inline-flex align-items-center mb-2">
                        <i className="ti ti-mail-forward text-gray-5 me-2" />
                        {company.Email}
                      </p>
                      <p className="text-dark d-inline-flex align-items-center mb-2">
                        <i className="ti ti-phone text-gray-5 me-2" />
                        {company.Phone}
                      </p>
                      <p className="text-dark d-inline-flex align-items-center">
                        <i className="ti ti-map-pin text-gray-5 me-2" />
                        {company.Location}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                      <div className="icons-social d-flex align-items-center">
                        <Link
                          to="#"
                          className="avatar avatar-rounded avatar-sm me-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            showBasicAlert("Coming Soon");
                          }}>
                          <i className="ti ti-mail" />
                        </Link>{" "}
                        <Link
                          to="#"
                          className="avatar avatar-rounded avatar-sm me-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            showBasicAlert("Coming Soon");
                          }}>
                          <i className="ti ti-phone-call" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => {
                e.preventDefault();
              }}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* <CrmsModal /> */}

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />

      <EditCompany data={modalData ?? defaultCompanyData} />
    </>
  );
};

export default CompaniesGrid;
